<iframe
  src="assets/docs/index.html"
  style="width: 100%; height: 100vh; border: none"
  frameborder="0"
></iframe>

